<template>
  <div class="footer" id="footer">
    <div class="contact-us-container">
      <img src="https://summit-img.geekpark.net/10-%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC.svg"
           style="width:60vw;margin-left: 11vw">
      <div class="contact-us">
        <div class="item">
          <h2>观众咨询</h2>
          <a href="mailto:IFX@geekpark.net">
            <img src="https://summit-img.geekpark.net/ifx@geekpark.net.svg" style="width:35vw">
          </a>
        </div>
        <div class="item">
          <h2>商务合作</h2>
          <a href="mailto:IF.BD@geekpark.net">
            <img src="https://summit-img.geekpark.net/if.bd@geekpark.net.svg" style="width: 40vw">
          </a>
        </div>
        <div class="item">
          <h2>媒体联系</h2>
          <a href="mailto:IF.Media@geekpark.net">
            <img src="https://summit-img.geekpark.net/if.media@geekpark.ne.svg" style="width: 45vw;">
          </a>
        </div>
      </div>
      <div class="geek-parker">
       <h4>添加极客君微信好友（ID：GEEKGOGO），发送「IFX」即可加入大会用户交流群</h4>
      </div>
    </div>
    <div style="position: relative">
      <img src="https://summit-img.geekpark.net/mobile/footer-m.jpg" style="width: 100%">
      <div class="past-container">
        <div style="text-align: left">
          <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-%E7%BA%A2%E8%89%B2" style="width: 17vw;">
        </div>
        <div class="past-year">
          <a href="http://if2019.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2019-%E7%99%BD-m.svg" alt="">
          </a>
          <a href="http://if2018.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2018-%E7%99%BD-m.svg" alt="">
          </a>
          <a href="http://if2017.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2017-%E7%99%BD-m.svg" alt="">
          </a>
          <a href="http://if2016.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2016-%E7%99%BD-m.svg" alt="">
          </a>
          <a href="http://if2015.geekpark.net/" target="_blank">
            <img src="https://summit-img.geekpark.net/mobile/v2-%E5%BE%80%E5%B1%8A%E5%9B%9E%E9%A1%BE-2015-%E7%99%BD-m.svg" alt="">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped lang="less">
  .footer{
    margin-top: 6vw;
    background: #000;
  }
  .contact-us-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100vw;
    height: 100vw;
    padding: 10vw 0;
    background-color: #2d2d2d;
    text-align: left;
  }

  .contact-us {
    width: 80%;
    margin: auto;

    .item {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #d8d8d8;

      &:not(:last-of-type) {
        margin-bottom: 4vw;
      }

      h2 {
        color: #fff;
        font-size: 5vw;
        font-weight: normal;
      }

      a {
        display: flex;
        justify-content: center;
      }
    }
  }

  .geek-parker {
    width: 80%;
    margin: 0 auto;
    color: #fff;
    font-size: 3.8vw;
    word-break: break-all;
    h4{
      font-weight: normal;
    }
    h4:last-child{
      margin-top: .5vw;
    }
  }

  .past-container{
    position: absolute;
    left: 9vw;
    bottom: 32vw;
    width: 82vw;

    .past-year{
      display: flex;
      justify-content: left;
      margin-top: 2vw;
      img{
        width: 15vw;
        margin-right: 2vw;
      }
    }
  }
</style>
